module.exports = __webpack_public_path__ + "img/Coming-Soon.21978082.jpg";